import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { SelectableFilterOption } from '../filter-categories-list/filter-categories-list.component';

export interface FactTempOptions {
  factuality: SelectableFilterOption[];
  temporality: SelectableFilterOption[];
}

/**
 * Factuality + Temporality column (one combined form control).
 */
@Component({
  selector: 'app-filter-facttemp-list',
  templateUrl: './filter-facttemp-list.component.html',
  styleUrls: ['./filter-facttemp-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterFacttempListComponent {
  @Input() factTemp: FactTempOptions = { factuality: [], temporality: [] };
  @Input() control: UntypedFormControl;

  @Output() toggleOption = new EventEmitter<SelectableFilterOption>();
}
